import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { map, shareReplay } from 'rxjs';
import { modalFadeTrigger } from 'src/app/core/animations';
import { DriversService } from 'src/app/core/services/drivers.service';
import { TelemetryService } from 'src/app/core/services/telemetry.service';
import { VehiclesService } from 'src/app/core/services/vehicles.service';


@Component({
  selector: 'app-route-driver-update-modal',
  templateUrl: './route-driver-update-modal.component.html',
  styleUrls: ['./route-driver-update-modal.component.scss'],
  animations: [modalFadeTrigger]
})
export class RouteDriverUpdateModalComponent implements OnInit {
  @HostBinding('@routeFadeState')
  @HostBinding('class.modal-info') true;
  public pending = false;
  public formErrors: string;
  @Input() text;
  @Input() submitFunc: Function;
  @Input() vehicleId: string;
  @Input() driverId: string;
  @Input() rideStartEventDate: string;
  @Input() parkStartEventDate: string;
  @Input() parkEndEventDate: string;
  private _txt = {
    header: 'UPDATE_DRIVER',
    body: 'CHANGE_DRIVER_CONFIRMATION',
    submit: 'UPDATE'
  };
  public txt;
  public form = this.buildForm();

  public drivers$ = this.driverService.list$()
      .pipe(
        shareReplay(),
        // Only include drivers with deletetAdd == null
        map(drivers => drivers.filter(driver => driver.deletedAt == null))
      );

  constructor(public activeModal: NgbActiveModal,
              private fb: FormBuilder,
              private vehicleService: VehiclesService,
              private telemetryService: TelemetryService,
              private toastr: ToastrService,
              private driverService: DriversService) {
  }

  ngOnInit() {
    this.txt = Object.assign({}, this._txt, this.text);
    this.form.patchValue({
      selectedDriver: this.driverId,
    });
  }

  buildForm() {
      return  this.fb.group({
        selectedDriver: [null],
      });
    }

  get showError() {
    return this.formErrors != null;
  }

  onSubmitClick() {
    this.pending = true;
    this.formErrors = null;
    const driverId = this.form.value.selectedDriver;
    if (driverId) {
      this.telemetryService.getVehiclesFromDriverRides(driverId, this.rideStartEventDate, this.parkStartEventDate).subscribe(vehicles => {
        console.log(vehicles);
        if (vehicles.length > 0) {
          this.pending = false;
          this.formErrors = this.getVehicleInfo(vehicles);
          return;
        } else {
          this.updateDriverRides(driverId);
        }
      });
    } else {
      this.updateDriverRides(driverId);
    }
    
  }

  updateDriverRides(driverId: string) {
    this.vehicleService.updateRidesDriver(
      this.vehicleId,
      driverId,
      this.rideStartEventDate,
      this.parkEndEventDate ? this.parkEndEventDate : this.parkStartEventDate).subscribe(() => {
          this.toastr.success('Kierowca został pomyślnie zaktualizowany. Zmiany mogą być widoczne w historii tras po kilkunastu sekundach.');
            this.activeModal.close(true);
          },
          (err) => {
            this.pending = false;
            this.formErrors = err;
        });
  }

  getVehicleInfo(vehicles: { vehicleId: string, vehicleName: string }[]): string {
    // it should return an information that the driver has rides with other vehicles in the given period, 
    // and list those vehicles as links in format (link should opern new browser tab):
    // https://stage-fleet-web.fleetconnect.pl/vehicles(popup:vehicle/{vehicleId}/history)?fromDatePopup=2026-02-16T23:00:00.000Z&toDatePopup=2026-02-17T22:59:59.999Z&dateTypePopup=selected
    // vehicles should be lister as bullet list
    return `Wybrany kierowca ma przypisane trasy z innymi pojazdami w tym okresie.` +
    // href should be relative so it will match on every environment (dev, stage, prod)
    ` Pojazdy te to: ${vehicles.map(v => 
      `<li><a target="_blank" href="/vehicles` + 
      `(popup:vehicle/${v.vehicleId}/history)?fromDatePopup=${this.rideStartEventDate}&`+
      `toDatePopup=${this.parkStartEventDate}&dateTypePopup=selected">${v.vehicleName}</a></li>`).join(' ')}`;
  }
}
